/**
* Team Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Team Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'team-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.team-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--team-slider' )[0], {
          type: 'loop',
          pagination: false,
          arrows: true,
          gap: '20px',
          // autoWidth: true,
          perPage: 4,
          perMove: 1,
          padding: {
            left: '17%',
            right: '17%',
          },
          breakpoints: {
            1440: {
              padding: {
                left: '80px',
                right: '80px',
              },
            },
            1024: {
              perPage: 1,
            },
            640: {
              perPage: 1,
              padding: {
                left: '40px',
                right: '40px',
              },
            },
          },
        } );

        splide.on( 'overflow', function( isOverflow ) {
          if ( !isOverflow ) {
            splide.options = {
              arrows: isOverflow,
              drag: isOverflow,
              clones: isOverflow ? undefined : 0,
            };
          }
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'team-slider', COMPONENT );
} )( app );
